module.exports = __webpack_public_path__ + "img/points-wallets.8e91e46f.svg";